
    import { mapState } from 'vuex';

    import Vue from 'vue';
    export default Vue.extend({
        props: {
            // eslint-disable-next-line vue/require-default-prop
            customer: {
                type: Object
            }
        },
        data() {
            return {
                UpdateDialog: false,
                snackbar: false,
                snackbarText: 'Customer details have been updated.',
                responseFromApi: null,
                customerToSave: { company: '', am_id: '' },
                notes: ''
            };
        },
        computed: {
            ...mapState({
                accountmanagers: (state: any) =>
                    state.customers.allAccountManagers
            })
        },
        created() {
            this.$store.dispatch('customers/getCustomersAndAMs');
            this.customerToSave = this.customer;
        },
        methods: {
            sendCustomerUpdateRequest() {
                this.$store
                    .dispatch(
                        'customers/updateCustomerDetail',
                        this.customerToSave
                    )
                    .then((response) => {
                        this.responseFromApi = response;
                        this.UpdateDialog = false;
                        this.snackbar = true;
                        this.resetForm();
                    })
                    .catch((error) => {
                        this.snackbarText = 'There was an error: ' + error;
                        this.snackbar = true;
                    });
            },
            cancelRequest() {
                this.resetForm();
                this.UpdateDialog = false;
            },
            resetForm() {
                this.notes = '';
            }
        }
    });
